import { createSlice } from "@reduxjs/toolkit";
import {
  addContainer,
  editContainer,
  getContainers,
} from "../APIs/containersAPI";

const initialState = {
  loading: false,
  error: {},
  status: "idle",
  containerList: {
    result: [],
    totalRecords: 0,
  },
  currentContainer: {},
  deleteContainerModal: {
    visible: false,
    data: {},
  },
  showToastMessage: {
    visible: false,
    data: {},
  },

  threeDotsPopoverId: 0,
};

export const containerSlice = createSlice({
  name: "containers",
  initialState,
  reducers: {
    updateContainer: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
  },
  extraReducers(builder) {
    // add containers
    builder.addCase(addContainer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addContainer.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(addContainer.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get containers
    builder.addCase(getContainers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getContainers.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.containerList = action.payload;
    });
    builder.addCase(getContainers.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // edit container
    builder.addCase(editContainer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(editContainer.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(editContainer.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });
  },
});

export const { updateContainer } = containerSlice.actions;

export default containerSlice.reducer;
